import { logAndToast } from './logAndToast';
import { type LogHelper, type Ctx } from '@types';

export const logError: LogHelper = async (
  message: string,
  source: string,
  context?: Ctx,
  showToast = true,
  forceLog = false
): Promise<void> => {
  await logAndToast({
    message,
    source,
    context,
    toast: showToast,
    level: 'error',
    forceLog
  });
};
